module.exports = __webpack_public_path__ + "img/tool-box.e4ccffb8.png";